import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const MonteiroEngenhariaLogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING._8};

  > div {
    display: flex;
    flex-direction: row;
    gap: ${SPACING._4};
    user-select: none;
  }
`;
